import { createAsyncThunk } from '@reduxjs/toolkit'
import { QueryClient } from '@tanstack/react-query'
import { AuthResponse } from '@/features/auth/types/authTypes'
import { authActions } from '../slices/authSlice'
import { userActions } from '../slices/userSlice'
import { authAction } from './authAction'

type ReturnTokenActionProps = {
  authResponse: AuthResponse
  queryClient: QueryClient
}

const returnTokenAction = createAsyncThunk(
  'returnTokenAction',
  async ({ authResponse, queryClient }: ReturnTokenActionProps, { dispatch }) => {
    await dispatch(authAction({ authResponse, queryClient })).unwrap()
    dispatch(authActions.deleteOriginalAuth())
    dispatch(userActions.deleteOriginalUser())
    queryClient.clear()
  },
)

export { returnTokenAction }
